import type { ReactNode } from "react";
import type { Language } from "./language.ts";
import { LanguageContext } from "./languageContext.ts";

/**
 * Wraps the whole app (see App.tsx) — the `language` value itself (state +
 * localStorage persistence) lives in App.tsx, same as `theme`; this
 * Provider only distributes it via context so any component can request
 * its text with `useT()` without threading it as a prop through every
 * intermediate level.
 */
export function LanguageProvider({
  language,
  children,
}: {
  language: Language;
  children: ReactNode;
}) {
  return <LanguageContext.Provider value={language}>{children}</LanguageContext.Provider>;
}
